/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-30 14:39:24
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-15 11:51:47
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ProductsSelection/TableCommon.tsx
 */
import css from './css.less';
import React from 'react';
import TagGroup from 'src/components/TagGroup/TagGroup';
import { EnumProductType } from 'src/types/common/product';

export const columns = ({ getI18n }) => [
  {
    title: '',
    dataIndex: 'thumbnailUrl',
    key: 'thumbnailUrl',
    default: true,
    optional: false,
    className: css.columnClass,
    render: (url, record) => {
      return <img width={40} height={40} key={url} src={url} alt={url} />;
    },
    width: 64,
  },
  {
    title: getI18n('general.sKU'),
    dataIndex: 'sku',
    default: true,
    optional: true,
    key: 'sku',
    className: css.columnClass,
    minWidth: 100,
  },
  {
    title: getI18n('general.productName'),
    dataIndex: 'name',
    default: true,
    optional: true,
    key: 'name',
    className: css.columnClass,
    sorter: (a, b) => {
      const name1 = a.name || '';
      const name2 = b.name || '';
      const n1 = name1.toLowerCase();
      const n2 = name2.toLowerCase();
      if (n1 > n2) return 1;
      if (n2 > n1) return -1;
      return 0;
    },
    minWidth: 220,
  },
  {
    title: getI18n('general.productType'),
    dataIndex: 'productType',
    default: true,
    optional: true,
    key: 'productType',
    sorter: (a, b) => {
      const name1 = a.productType || '';
      const name2 = b.productType || '';
      const n1 = name1.toLowerCase();
      const n2 = name2.toLowerCase();
      if (n1 > n2) return 1;
      if (n2 > n1) return -1;
      return 0;
    },
    minWidth: 100, //EnumProductType
    childGenerate: (text, record, index) => {
      const { productType } = record;
      const dict = {
        [EnumProductType.GiftCard]: getI18n('general.giftCard'),
        [EnumProductType.Service]: getI18n('general.service'),
        [EnumProductType.Set]: getI18n('general.set'),
        [EnumProductType.Simple]: getI18n('general.simple'),
      };
      return dict[productType] || '';
    },
  },
  //
  {
    title: getI18n('general.remarks'),
    dataIndex: 'remarks',
    default: true,
    optional: true,
    key: 'remarks',
    className: css.columnClass,
    minWidth: 100,
  },

  {
    title: getI18n('general.tags'),
    dataIndex: 'tags',
    default: true,
    optional: true,
    align: 'center',
    className: css.columnClass,
    key: 'tags',
    minWidth: 150,
    tags: true,
    tagsGenerator: (
      characterLength,
      width,
      marginPaddingWidth,
      containPaddingWidth,
      tags,
      record,
    ) => {
      return (
        <TagGroup
          characterLength={characterLength}
          containerWidth={width}
          marginPaddingWidth={marginPaddingWidth}
          containPaddingWidth={containPaddingWidth}
          tags={tags}
        />
      );
    },
  },
];
export const collectionColumns = ({ getI18n }) => [
  {
    title: '',
    dataIndex: 'thumbnailUrl',
    key: 'thumbnailUrl',
    default: true,
    optional: false,
    className: css.columnClass,
    render: (url, record) => {
      return <img width={40} height={40} key={url} src={url} alt={url} />;
    },
    width: 56,
  },

  {
    title: getI18n('general.productName'),
    dataIndex: 'productName',
    default: true,
    optional: true,
    key: 'productName',
    className: css.columnClass,
    minWidth: 236,
  },
  {
    title: getI18n('general.type'),
    dataIndex: 'alias',
    default: true,
    optional: true,
    key: 'alias',
    className: css.columnClass,
    minWidth: 70,
    render: (text, record) =>
      text === true ? getI18n('general.alias') : getI18n('general.original'),
  },
  {
    title: getI18n('general.remarks'),
    dataIndex: 'remarks',
    default: true,
    optional: true,
    key: 'remarks',
    className: css.columnClass,
    minWidth: 120,
  },

  {
    title: getI18n('general.tags'),
    dataIndex: 'tags',
    default: true,
    optional: true,
    align: 'center',
    className: css.columnClass,
    key: 'tags',
    minWidth: 200,
    tags: true,
    tagsGenerator: (
      characterLength,
      width,
      marginPaddingWidth,
      containPaddingWidth,
      tags,
      record,
    ) => {
      return (
        <TagGroup
          characterLength={characterLength}
          containerWidth={width}
          marginPaddingWidth={marginPaddingWidth}
          containPaddingWidth={containPaddingWidth}
          tags={tags}
        />
      );
    },
  },
];
export const salesChannelColumns = ({ getI18n }) => [
  {
    title: '',
    dataIndex: 'thumbnailUrl',
    key: 'thumbnailUrl',
    default: true,
    optional: false,
    className: css.columnClass,
    render: (url, record) => {
      return <img width={40} height={40} key={url} src={url} alt={url} />;
    },
    width: 64,
  },
  {
    title: getI18n('general.productName'),
    dataIndex: 'productName',
    default: true,
    optional: true,
    key: 'productName',
    className: css.columnClass,
    minWidth: 140,
  },
  {
    title: getI18n('general.type'),
    dataIndex: 'productType',
    default: true,
    optional: true,
    key: 'productType',
    className: css.columnClass,
    minWidth: 220,
    childGenerate: (text, record, index) => {
      const { productType } = record;
      const dict = {
        [EnumProductType.GiftCard]: getI18n('general.giftCard'),
        [EnumProductType.Service]: getI18n('general.service'),
        [EnumProductType.Set]: getI18n('general.set'),
        [EnumProductType.Simple]: getI18n('general.simple'),
      };
      return dict[productType] || '';
    },
  },
  {
    title: getI18n('general.remarks'),
    dataIndex: 'remarks',
    default: true,
    optional: true,
    key: 'remarks',
    className: css.columnClass,
    minWidth: 110,
  },

  {
    title: getI18n('general.tags'),
    dataIndex: 'tags',
    default: true,
    optional: true,
    align: 'center',
    className: css.columnClass,
    key: 'tags',
    minWidth: 200,
    tags: true,
    tagsGenerator: (
      characterLength,
      width,
      marginPaddingWidth,
      containPaddingWidth,
      tags,
      record,
    ) => {
      return (
        <TagGroup
          characterLength={characterLength}
          containerWidth={width}
          marginPaddingWidth={marginPaddingWidth}
          containPaddingWidth={containPaddingWidth}
          tags={tags}
        />
      );
    },
  },
];
